import React from 'react';
import useCompanyGeneralData from './hooks/useCompanyGeneralData';
import Forward from './form/Forward';

export default function AdminForward() {
    const { data: { data }, saveExtra, reloadData } = useCompanyGeneralData();
    return <Forward data={data?.companyData ?? {}} save={saveExtra} reloadData={reloadData} />;
}
